import { DEFAULT_LABEL_COLORS } from './blocosKanbanUtils'

export function normalizeLabelColor(color?: string | null): string {
  if (color && /^#[0-9A-Fa-f]{6}$/.test(color)) return color
  return DEFAULT_LABEL_COLORS[0]
}

export function hexToRgba(hex: string, alpha: number): string {
  const h = hex.replace('#', '')
  const r = parseInt(h.slice(0, 2), 16)
  const g = parseInt(h.slice(2, 4), 16)
  const b = parseInt(h.slice(4, 6), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
